import { useContext } from 'react';

import { SkillGapPercentage } from './SkillGapPercentage';
import { SkillsBarChartDataGridCell } from './SkillsBarChartDataGridCell';
import { SkillsBarChartDataGridHeader } from './SkillsBarChartDataGridHeader';
import { ApplicationContext } from '../../../../../shared/source/context/context';
import { SkillChipWithDrawer } from '../../common/skills/SkillChipWithDrawer';

import type { GlobalSearchSkill } from '../../../data-contract/global-search';
import type { GridColDef } from '@mui/x-data-grid-pro';

type SkillsColumnsProps = {
    readonly openRowId?: string;
    readonly withLearningOpportunities: boolean;
};

export const SkillsBarChartColumns = ({
    openRowId,
    withLearningOpportunities,
}: // eslint-disable-next-line functional/prefer-readonly-type
SkillsColumnsProps): GridColDef<GlobalSearchSkill>[] => {
    const { translate } = useContext(ApplicationContext);

    return [
        {
            disableColumnMenu: true,
            field: 'title',
            flex: 1,
            headerName: translate('pages.global-search.headlines.skill'),
            maxWidth: 360,
            renderCell: (params) => {
                const skill = params.row;

                return <SkillChipWithDrawer label={skill.title} skillId={skill.id} type={skill.skillType} />;
            },
            resizable: false,
            sortable: false,
            valueGetter: ({ row }) => row,
        },
        {
            disableColumnMenu: true,
            field: 'barChart',
            renderCell: (params) => {
                const skill = params.row;

                return (
                    <SkillsBarChartDataGridCell
                        isRowOpen={skill.id === openRowId}
                        skill={skill}
                        withLearningOpportunities={withLearningOpportunities}
                    />
                );
            },
            renderHeader: () => <SkillsBarChartDataGridHeader withLearningOpportunities={withLearningOpportunities} />,
            resizable: false,
            sortable: false,
            width: 660,
        },
        {
            align: 'right',
            disableColumnMenu: true,
            field: 'skillGapRelative',
            headerName: translate('pages.global-search.headlines.skill-gap-relative'),
            renderCell: (params) => <SkillGapPercentage skill={params.row} />,
            resizable: false,
            sortable: false,
        },
    ];
};
